import React from 'react';
import { Button } from 'carbon-components-react';

const Password: React.FC<Props> = () => {
  const handleClickChangePassword = () => {
    window.open(
      `${process.env.REACT_APP_IDENTITY_WEB_URL}/profile?tab=change_password`,
      'profileNewWindow'
    );
  };

  return (
    <div id="password" className="password spacing-padding">
      <div className="sub-section-title">Password</div>
      <div className="change-password-button-container">
        <Button
          kind="tertiary"
          size="default"
          className="button-size"
          onClick={handleClickChangePassword}
        >
          Change password
        </Button>
      </div>
    </div>
  );
};

interface Props {
  user: any;
}

export default React.memo(Password);
